(function () {
    'use strict';
    var controllerId = 'justgageCtrl';

    angular.module('app').controller(controllerId, ['$scope', '$filter', justgageCtrl]);


    function justgageCtrl($scope, $filter) {
        var self = this;

        /*
         * Collection of functions to override the default transformation of JustGage parameter options.
         * Each function should return a value acceptable as a JustGage parameter.
         */
        self.getOptionValueOverrides = {            
            customsectors: angular.fromJson,
            levelcolors: angular.fromJson,
            textrenderer: function (originalFunction) {
                if (!originalFunction) {
                    return undefined;
                }
                if (angular.isFunction(originalFunction)) {
                    return originalFunction();
                }
                return originalFunction;
            }
        };

        /**
             * Transform the string-like option value into a real option that can be passed to JustGage.
             * The option name is used to check if there is any override transform function that can be used instead
             * of this function's default implementation.
             * @param {object} name - The name of the option to transform.
             * @param {object} value - The value to transform.
             * @returns {object} - The transformed value.
             */
        self.getOptionValue = function (name, value) {
            if (name == 'levelcolors') 
                value = value.replace(/'/g, '"');            
            
            var overrideFunction = self.getOptionValueOverrides[name];
            if (overrideFunction) {
                return overrideFunction(value);
            }
            if (value === '') {
                return undefined;
            }
            if (value === 'true') {
                return true;
            }
            if (value === 'false') {
                return false;
            }

            return value;
        };

        //Traduzione dal nome proveniente dalla direttiva al nome richiesto dalla libreria 
        self.getOptionName = function (optionName) {
            if (optionName === "titlefontcolor") optionName = "titleFontColor";
            if (optionName === "valuefontcolor") optionName = "valueFontColor";
            if (optionName === "relativegaugesize") optionName = "relativeGaugeSize";
            if (optionName === "valueminfontsize") optionName = "valueMinFontSize";
            if (optionName === "titleminfontsize") optionName = "titleMinFontSize";
            if (optionName === "labelminfontsize") optionName = "labelMinFontSize";
            if (optionName === "labelminfontsize") optionName = "minLabelMinFontSize";
            if (optionName === "maxlabelminfontsize") optionName = "maxLabelMinFontSize";
            if (optionName === "hidevalue") optionName = "hideValue";
            if (optionName === "hideminmax") optionName = "hideMinMax";
            if (optionName === "hideinnershadow") optionName = "hideInnerShadow";
            if (optionName === "gaugewidthscale") optionName = "gaugeWidthScale";
            if (optionName === "gaugecolor") optionName = "gaugeColor";
            if (optionName === "showinnershadow") optionName = "showInnerShadow";
            if (optionName === "shadowopacity") optionName = "shadowOpacity";
            if (optionName === "shadowsize") optionName = "shadowSize";
            if (optionName === "shadowverticaloffset") optionName = "shadowVerticalOffset";
            if (optionName === "levelcolors") optionName = "levelColors";
            if (optionName === "customsectors") optionName = "customSectors";
            if (optionName === "nogradient") optionName = "noGradient";
            if (optionName === "labelfontcolor") optionName = "labelFontColor";
            if (optionName === "startanimationtTime") optionName = "startAnimationTime";
            if (optionName === "startanimationtype") optionName = "startAnimationType";
            if (optionName === "refreshanimationtime") optionName = "refreshAnimationTime";
            if (optionName === "refreshanimationtype") optionName = "refreshAnimationType";
            if (optionName === "donutstartangle") optionName = "donutStartAngle";
            if (optionName === "formatnumber") optionName = "formatNumber";
            if (optionName === "humanfriendly") optionName = "humanFriendly";
            if (optionName === "humanfriendlydecimal") optionName = "humanFriendlyDecimal";
            if (optionName === "textrenderer") optionName = "textRenderer";

            return optionName;
        };

        /**
             * Get all option names from the scope, excluding the ones in the given array.
             * @param {Array|string} exclude - String or Array of strings containing the names to exclude from the result.
             * @returns {Array} - Strings of the valid option names.
             */
        self.getOptionsNames = function (exclude) {
            var optionsNames = [];
            var exclusionArray = exclude || [];
            // Transform the basic object into an array
            if (angular.isDefined(exclude) && !angular.isArray(exclude)) {
                exclusionArray = [exclude];
            }
            // Add the name to the returning array iif it's not 'this', it doesn't start with a '$' and it is not excluded
            angular.forEach($scope, function (el, key) {
                if (key !== 'this' && key.substring(0, 1) !== '$') {
                    optionsNames.push(key);
                }
            });

            return optionsNames;
        };

        /**
             * Get all options which have a defined value.
             * @returns {object} - Object of valid options.
             */
        self.getDefinedOptions = function () {
            var options = {};
            var optionNames = self.getOptionsNames();
            angular.forEach(optionNames, function (el) {
                if (el !== 'this' && el.substring(0, 1) !== '$' && $scope[el]) {

                    options[self.getOptionName(el)] = self.getOptionValue(el, $scope[el]);
                }
            });

            return options;
        };
    }
})();
